/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

const isFloor = locationType => locationType === 'floor';

export default isFloor;
